import { Component, inject } from '@angular/core';
import { OdataService } from '@methylium/odata';
import { ListLazyComponent } from '@ml-ag-grid-lib';
import { PanelComponent, PanelHeaderComponent, TitleComponent } from '@rocksoft/cdk';
import { DevicesService } from '@rocksoft/mdm-sdk-v2';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { DevicesOverviewDatasource } from './devices-overview-datasource';
import { MdmDevicesAgGridCellRendererComponent } from './mdm-devices-ag-grid-cell-renderer/mdm-devices-ag-grid-cell-renderer.component';
import { MdmDevicesAgGridHeaderComponent } from './mdm-devices-ag-grid-header/mdm-devices-ag-grid-header.component';

@Component({
  selector: 'ml-mdm-devices-overview',
  templateUrl: './devices-overview.component.html',
  imports: [PanelComponent, PanelHeaderComponent, TitleComponent, ListLazyComponent],
})
export class DevicesOverviewComponent {
  private readonly api = inject(DevicesService);
  private readonly odataService = inject(OdataService);

  public dataSource: DevicesOverviewDatasource;

  public columnDefs: ColDef[] = [
    {
      field: 'serialNumber',
      sortable: true,
      pinned: 'left',
      suppressMovable: true,
      resizable: false,
      headerComponent: MdmDevicesAgGridHeaderComponent,
      cellRenderer: MdmDevicesAgGridCellRendererComponent,
      wrapText: true,
      cellClass: 'ml-custom-cell',
      headerClass: 'ml-custom-header-cell',
      filter: 'agTextColumnFilter',
      filterParams: {
        maxNumConditions: 1,
      },
    },
  ];

  constructor() {
    this.dataSource = new DevicesOverviewDatasource(this.api, this.odataService);
  }

  public onGridReady(gridReadyEvent: GridReadyEvent): void {
    gridReadyEvent.api.hideOverlay();
  }
}
